module.exports = __webpack_public_path__ + "img/iphone-7.8b6944d0.svg";